(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!window.matchMedia('(min-width: 990px)').matches) return;
  if (window.matchMedia('(pointer: coarse)').matches) return;

  document.documentElement.classList.add('dtk-mouse-fx');

  const cursor = document.createElement('div');
  cursor.className = 'dtk-cursor';
  cursor.setAttribute('aria-hidden', 'true');
  cursor.innerHTML = '<span class="dtk-cursor__ring"></span><span class="dtk-cursor__dot"></span>';
  document.body.appendChild(cursor);

  const ring = cursor.querySelector('.dtk-cursor__ring');
  const dot = cursor.querySelector('.dtk-cursor__dot');

  let targetX = window.innerWidth / 2;
  let targetY = window.innerHeight / 2;
  let dotX = targetX;
  let dotY = targetY;
  let ringX = targetX;
  let ringY = targetY;
  let isVisible = false;
  let isHover = false;
  let isHidden = false;

  const hoverSelector =
    'a, button, input[type="submit"], input[type="button"], label[for], summary, [role="button"], .button, .card-wrapper, .header__icon';

  function setVisible(visible) {
    isVisible = visible;
    cursor.classList.toggle('is-visible', visible);
  }

  function setHover(hover) {
    isHover = hover;
    cursor.classList.toggle('is-hover', hover);
  }

  function setHidden(hidden) {
    isHidden = hidden;
    cursor.classList.toggle('is-hidden', hidden);
  }

  document.addEventListener(
    'mousemove',
    (event) => {
      targetX = event.clientX;
      targetY = event.clientY;
      if (!isVisible) setVisible(true);

      const target = event.target.closest(hoverSelector);
      const inField = event.target.closest('input, textarea, select, [contenteditable="true"]');
      const inVideo = event.target.closest('.dtk-video-text__media');
      setHover(!!target && !inField && !inVideo);
      setHidden(!!inField || !!inVideo);
    },
    { passive: true }
  );

  document.addEventListener('mouseleave', () => setVisible(false));
  document.addEventListener('mouseenter', () => setVisible(true));

  function animateCursor() {
    dotX += (targetX - dotX) * 0.22;
    dotY += (targetY - dotY) * 0.22;
    ringX += (targetX - ringX) * 0.1;
    ringY += (targetY - ringY) * 0.1;

    dot.style.transform = `translate3d(${dotX}px, ${dotY}px, 0) translate(-50%, -50%)`;
    ring.style.transform = `translate3d(${ringX}px, ${ringY}px, 0) translate(-50%, -50%)`;

    requestAnimationFrame(animateCursor);
  }

  animateCursor();

  function bindHeroParallax() {
    const heroMedia = document.querySelector(
      '.template-index .shopify-section:first-of-type .banner__media img, .template-index .shopify-section:first-of-type .banner__media .media img'
    );
    const heroSection = document.querySelector('.template-index .shopify-section:first-of-type .banner');

    if (!heroMedia || !heroSection || heroSection.dataset.dtkParallax) return;
    heroSection.dataset.dtkParallax = 'true';
    heroMedia.classList.add('dtk-hero-parallax');

    heroSection.addEventListener('mousemove', (event) => {
      const rect = heroSection.getBoundingClientRect();
      const x = (event.clientX - rect.left) / rect.width - 0.5;
      const y = (event.clientY - rect.top) / rect.height - 0.5;
      heroMedia.style.transform = `scale(1.06) translate3d(${x * 18}px, ${y * 12}px, 0)`;
    });

    heroSection.addEventListener('mouseleave', () => {
      heroMedia.style.transform = '';
    });
  }

  function init() {
    bindHeroParallax();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
